// extracted by mini-css-extract-plugin
export default {"container":"MyOffersContainer_container__26TL-","content":"MyOffersContainer_content__6Tuez"};